import { render, staticRenderFns } from "./FailureModeTabDialog.vue?vue&type=template&id=c72c6124&scoped=true"
import script from "./FailureModeTabDialog.vue?vue&type=script&lang=ts"
export * from "./FailureModeTabDialog.vue?vue&type=script&lang=ts"
import style0 from "./FailureModeTabDialog.vue?vue&type=style&index=0&id=c72c6124&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c72c6124",
  null
  
)

export default component.exports